import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import FunFactsArchitecture3 from "../../components/FunFacts/FunFactsArchitecture3";

import Gallery from "../../components/Gallery/Gallery";



import CTAOne from "../../components/CTA/CTAOne";


const paragraph2 = (
  <>
    {`Here's How ${new Date().getFullYear()} Is Adding Up So Far:`}
    <br />
    {`YTD Average Price Comparison of All Property Types`}
  </>
);

const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef(); 
  const rentals = useRef();
  const contact = useRef();

  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
          break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className=" mt-minus-50">
        <div className="container mt-minus-50">
      <div className="row mt-minus-50">
        <HeadingSection
       
          classAppend="dark-color"
        > <h2>OUR SERVICES</h2></HeadingSection>
      </div>
     
     <h2>PROPERTY &amp; INVESTMENT MANAGEMENT</h2><br />

<p>Olshan is a 5-star Award/Circle of Excellence winner presented by Cartus Relocation and Dwellworks which has employed Olshan’s relocation services since 1981. Our Investor/Property Management division is overseen by award-winning property manager Jennifer Stutz, who is one of the finest in the country. Jennifer handles the properties of investors and relocating executives and oversees a portfolio ranging from apartments to townhouses throughout New York City. Services include overseeing payment of monthly homeowner fees, arranging for repairs, dealing with vendors for absentee owners and serving as a liaison between owners, tenants, co-op and condo boards and managing agents. For investor clients, she provides market reports which comprise relevant data, projections of revenue and return on investment (ROI).</p>

<h3>SERVICES:</h3>
<ul>
<li>Property evaluation/Broker Price Opinion (BPO)</li>
<li>Apartment prep (painting/floors/cleaning)</li>
<li>Co-brokering the rental or sale listing</li>
<li>Finding a qualified tenant or purchaser.</li>
<li>Preparing leases</li>
<li>Obtaining coop/condo board approval.</li>
<li>Establishing the tenant in the apartment.</li>
<li>Providing lease extensions as necessary.</li>
<li>Day-to-day tenant relations.</li>
<li>Accounting and billing</li>
<li>Performing routine inspections</li>
<li>Overseeing all repairs and requests</li>
</ul>

<p><strong>For More information:</strong><br />
Jennifer Stuz<br />
<a href="MAILTO:Jennifer Stuz
jms@olshan.com">jms@olshan.com</a><br />
917-887-5605<br /></p>


    </div>
    </section>

    <FunFactsArchitecture3
                
                title={new Date().getFullYear()}
                tagline="By The Numbers"
                paragraph1="In 2024 the average asking price in the luxury sector ($4 million and above) was 4%
                higher than 2023. Once again, condos outsold co-ops more than 3-to-1, reflecting an ongoing trend: The
                average luxury buyer wants the freedom of condo ownership, new construction, and a
                robust menu of amenities. Townhouse sales were flat."
                paragraph2={paragraph2}  paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`}  paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
              />


    <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

<CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};



export default Architecture;
